import {GET_ERRORS_SUCCESS} from "../../../reducers/errorsReducer";


export const getErrorsSuccess = (payload) =>{

    return {
        type: GET_ERRORS_SUCCESS,
        payload
    }
}